
/**
 * Load required plugin.
 */
window.Lazy = require('jquery-lazy');

/**
 * Configure the plugin.
 */

+function($){
  page.registerVendor('Lazy');

  page.initLazy = function() {
    
    //if (typeof lazy !== 'function') {
        $("img.lazy").lazy();
    //}

  }

}(jQuery);



